import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  GET_MEMBER_MEASURES_REQUEST: '',
  GET_MEMBER_MEASURES_SUCCESS: '',
  GET_MEMBER_MEASURES_FAILURE: '',

  ADD_TO_HCC_DOCS_REQUEST: '',
  ADD_TO_HCC_DOCS_SUCCESS: '',
  ADD_TO_HCC_DOCS_FAILURE: '',

  GET_PROVIDER_HCC_MEMBER_DETAIL_PRINT_FILE_REQUEST: '',
  GET_PROVIDER_HCC_MEMBER_DETAIL_PRINT_FILE_SUCCESS: '',
  GET_PROVIDER_HCC_MEMBER_DETAIL_PRINT_FILE_FAILURE: '',

};

types = setStoreTypeValues(types, 'authHCC');

export default types;
